export const getResponsiveVisibility = (
  showOnDesktop = true,
  showOnMobile = true
) => {
  if (!showOnDesktop && !showOnMobile) {
    return 'hidden'
  }

  if (showOnDesktop && !showOnMobile) {
    return 'restructure-maxTablet:hidden'
  }

  if (!showOnDesktop && showOnMobile) {
    return 'restructure-small-desktop:hidden'
  }

  return ''
}
